import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { LoginCallbacks } from '@/legacy/components/user/signin/sessionTimeout/SessionTimeout.reducer';
import { getSingleSignOnLoginRequest } from '@/legacy/features/user/singleSignOn/services/api';

interface SsoSessionTimeoutDialogProps extends LoginCallbacks {
  email: string;
  isOpen: boolean;
}

function getRoute(): string {
  return window.location.hash;
}

const SsoSessionTimeoutDialog = (props: SsoSessionTimeoutDialogProps): React.JSX.Element => {
  const { email, isOpen, onLogout } = props;
  const formRef = useRef<HTMLFormElement>(null);
  const samlRequestRef = useRef<HTMLInputElement>(null);

  const handleLogout = () => {
    onLogout();
  };

  const handleLogin = () => {
    getSingleSignOnLoginRequest(email).then((response) => {
      formRef.current.action = response.url;
      samlRequestRef.current.value = response.samlRequest;
      formRef.current.submit();
    });
  };

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="timeout-dialog-title"
      aria-describedby="timeout-dialog-description"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="timeout-dialog-title" variant="h4">
        <FormattedMessage defaultMessage="Session Expired" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText variant="body1">
          <FormattedMessage defaultMessage="Your session has expired due to inactivity. Please sign in using SSO to resume your session or press the logout button to logout." />
        </DialogContentText>

        <form ref={formRef} method="POST">
          <input type="hidden" id="SAMLRequest" name="SAMLRequest" ref={samlRequestRef} />
          <input type="hidden" id="RelayState" name="RelayState" value={getRoute()} />
        </form>

        <DialogActions>
          <Button onClick={handleLogout} variant="outlined" size="large">
            <FormattedMessage defaultMessage="Logout" />
          </Button>

          <Button type="submit" color="primary" size="large" onClick={handleLogin}>
            <FormattedMessage defaultMessage="Sign in with SSO" />
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export { SsoSessionTimeoutDialogProps };
export default SsoSessionTimeoutDialog;
